import moment = require('@tableau/metrics-engine/node_modules/moment');
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import _ = require('underscore');

import { Messages } from '~src/codegen/Localize';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

import { GetResourceGovernanceServerSettingsRequest, IGetResourceGovernanceServerSettingsResult, IResourceGovernanceServerSettings } from '../types/ResourceGovernance';
import { openResourceGovernanceEditDefaultLimitsDialog } from './ResourceGovernanceEditDefaultLimitsDialog';
import { SchedulesGovernanceLimitsCard } from './SchedulesGovernanceLimitsCard';

export const LIMITS_BUTTON_TEST_ID = 'default-limits';
export class SchedulesGovernanceLimitsSection extends React.PureComponent<{}, IResourceGovernanceServerSettings>{
  public componentDidMount() {
    WebHttpClientWithErrorToastInstance.sendRequest(new GetResourceGovernanceServerSettingsRequest())
      .then((result: IGetResourceGovernanceServerSettingsResult) => {
        if (result.errors?.length) {
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.errorUnknown() });
          return;
        }

        this.setState({ ...result.governanceServerSettings });
      });
  }

  public render() {
    const nonDefaultSettings = this.state?.extractsConcurrencyLimit !== undefined
      || this.state?.subscriptionsConcurrencyLimit !== undefined
      || this.state?.flowsConcurrencyLimit !== undefined
      || this.state?.runtimeLimit !== undefined;
    const buttonText = nonDefaultSettings
      ? Messages.resourceGovernanceEditDefaultTitle()
      : Messages.resourceGovernanceSetDefaultTitle();
    return <>
      {<SchedulesGovernanceLimitsCard {...this.state} />}
      <ButtonWidget
        testId={LIMITS_BUTTON_TEST_ID}
        buttonType={ButtonType.Primary}
        children={buttonText}
        style={{ marginTop: 12 }}
        onClick={() => openResourceGovernanceEditDefaultLimitsDialog({ ...this.state, title: buttonText })}
      />
    </>;
  }
}